






/* globals google */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Loader } from '@googlemaps/js-api-loader';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import {} from 'google.maps';
import { Location } from '@/models/location.model';

@Component
export default class GoogleMap extends Vue {
  //replace apiKey prop with a get function?
  @Prop() private apiKey!: string;
  @Prop({
    default() {
      return {
        center: { lat: 41.95766534107732, lng: -87.67357280901598 },
        zoom: 19,
        mapTypeControl: false,
        streetViewControl: false
      };
    }
  })
  private mapConfig!: {
    center: { lat: number; lng: number };
    zoom: number;
  };
  @Prop() private locations!: Location[];
  @Prop() private cluster!: boolean;

  private loader = new Loader({
    apiKey: this.apiKey,
    version: 'quarterly',
    libraries: ['places']
  });

  private map!: google.maps.Map;
  private bounds!: google.maps.LatLngBounds;
  private markersArray!: google.maps.Marker[];
  private markerClusterer!: MarkerClusterer;

  @Watch('locations')
  watcherFunction(newLocations: Location[]): void {
    const newLoc = newLocations[newLocations.length - 1];
    this.addMarker(newLoc);
    this.map.fitBounds(this.bounds);
    if (this.cluster) {
      this.markerClusterer.addMarker(
        this.markersArray[this.markersArray.length - 1]
      );
    }
  }

  mounted(): void {
    // Instantiate map, bounds, markersArray
    this.loader
      .load()
      .then(() => {
        this.map = new google.maps.Map(
          document.getElementById('map') as HTMLElement,
          this.mapConfig
        );
        this.bounds = new google.maps.LatLngBounds();
        this.markersArray = [];

        // Add a marker for each location in the array.
        this.locations.forEach(this.addMarker);

        if (this.cluster) {
          this.clusterMarkers();
        }

        if (this.locations.length === 1) {
          this.map.setCenter(
            this.locations[0].position as google.maps.LatLngLiteral
          );
        } else {
          // Use our bounds object to properly center and zoom our map.
          this.map.fitBounds(this.bounds);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  addMarker(loc: Location): void {
    // Instantiate a marker for a location
    const marker = new google.maps.Marker({
      position: loc.position as google.maps.LatLngLiteral,
      map: this.map,
      title: loc.title
    });

    // Instantiate an info window the marker.
    if (loc.description) {
      marker.addListener('click', () => {
        const infoWindow = new google.maps.InfoWindow();
        infoWindow.setContent(
          '<div style = "width:200px;min-height:40px">' +
            loc.description +
            '</div>'
        );
        infoWindow.open(this.map, marker);
      });
    }

    // Add marker to array
    this.markersArray.push(marker);

    // Add each location to our bounds object
    this.bounds.extend(loc.position as google.maps.LatLngLiteral);
  }

  clusterMarkers(): void {
    this.markerClusterer = new MarkerClusterer(this.map, this.markersArray, {
      imagePath:
        'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    });
  }

  setMapOnAll(map: google.maps.Map | null): void {
    this.markersArray.forEach((marker) => {
      marker.setMap(map);
    });
  }

  hideMarkers(): void {
    if (this.cluster) {
      this.markerClusterer.clearMarkers();
    } else {
      this.setMapOnAll(null);
    }
  }

  showMarkers(): void {
    if (this.cluster) {
      this.clusterMarkers();
    } else {
      this.setMapOnAll(this.map);
    }
  }

  deleteMarkers(): void {
    this.hideMarkers();
    this.markersArray = [];
  }
}
